<template>
  <b-breadcrumb :items="items" class="al-breadcrumb" test-id="al-breadcrumb">
    <slot />
  </b-breadcrumb>
</template>

<script>
import { BBreadcrumb } from 'bootstrap-vue';

export default {
  components: {
    BBreadcrumb
  },
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss">
/**
 * Variables
 */
$font-size-navigation: 12.8px;
$font-color-navigation: color(black, lighten, 2);
$pl-breadcrumb-item: 4px;
$pr-breadcrumb-item: $pl-breadcrumb-item;

.al-breadcrumb {
  background-color: transparent;
  color: $font-color-navigation;
  font-size: $font-size-navigation;
  font-weight: bold;
  margin-bottom: 0;
  padding: 0;
  text-transform: uppercase;

  .breadcrumb-item {
    a {
      color: $font-color-navigation;
    }

    &::before,
    &.active {
      color: $font-color-navigation;
    }

    + .breadcrumb-item {
      padding-left: $pl-breadcrumb-item;

      &::before {
        padding-right: $pr-breadcrumb-item;
      }
    }

    &:last-child {
      a {
        color: color(black, lighten, 3);
        cursor: default;

        &:hover {
          text-decoration: none;
        }
      }
    }
  }
}
</style>
